module.exports = __webpack_public_path__ + "assets/images/5958409d162cec0591902b254e416ca1.svg";